<template>
    <div class="noticeonline">
        <div class="noticebody">
            <div class="online-item" :class="{ 'online-item-limit': data1.currentValue > data1.limitValue }">
                <img class="img"
                    :src="require('@/assets/newscreen/noticebg' + (data1.currentValue > data1.limitValue ? '-limit' : '') + '.png')" />
                <div class="content">
                    <div ><span style="font-size: 1.2rem;" class="HF-Duguts">{{ data1.currentValue }}</span> dB</div>
                    <div>1#厂界西监测点</div>
                    <div>噪声·{{ data1.currentValue > data1.limitValue ? '' : '未' }}超限</div>
                    <div>(限值{{ data1.limitValue }}dB)</div>
                </div>
            </div>
            <div class="online-item" :class="{ 'online-item-limit': data2.currentValue > data2.limitValue }">
                <img class="img"
                    :src="require('@/assets/newscreen/noticebg' + (data2.currentValue > data2.limitValue ? '-limit' : '') + '.png')" />
                <div class="content">
                    <div><span style="font-size: 1.2rem;" class="HF-Duguts">{{ data2.currentValue }}</span> dB</div>
                    <div>2#厂界北监测点</div>
                    <div>噪声·{{ data2.currentValue > data2.limitValue ? '' : '未' }}超限</div>
                    <div>(限值{{ data2.limitValue }}dB)</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
    props: ["changjieList"],
    components: {
        CountTo
    },
    computed: {
    },
    data() {
        return {
            startVal: 0,
            duration: 1000,
        }
    },
    computed: {
        data1() {
            // return this.changjieList.find(e => e.remark === '噪声-1')?.['噪声-1'] || {}
            const item = this.changjieList.find(e => e.remark === '噪声-1') || {}
            return item['噪声-1'] || {}
        },
        data2() {
            // return this.changjieList.find(e => e.remark === '噪声-2')?.['噪声-2'] || {}
            const item = this.changjieList.find(e => e.remark === '噪声-2') || {}
            return item['噪声-2'] || {}
        },
    },
    mounted() {
        console.log(22222222, this.changjieList)
        // this.changjieList.forEach(item => {
        //     if (item.remark == "噪声-1") {
        //         this.data1 = item["噪声-1"]
        //     }
        //     if (item.remark == "噪声-2") {
        //         this.data2 = item["噪声-2"]
        //     }
        // })
    },
    destroyed() {
        // clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
.noticeonline {
    padding: 0.5rem;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-size: 1rem;

    .noticebody {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
        justify-content: space-around;
    }

    .online-item {
        height: 100%;
        // background: url(../../../assets/newscreen/noticebg.png) no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
            display: block;
            height: 100%;
        }

        .content {
            width: calc(100% - 30px);
            position: absolute;
            // left: 0;
            // right: 0;
            // top: 25%;
            // margin: auto;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 0.65rem;
        }

        &-limit {
            // background: url(../../../assets/newscreen/noticebg-limit.png) no-repeat;
            background-size: 100% 100%;
        }
    }

    .on-title {
        background-image: linear-gradient(180deg, rgba(115, 226, 255, 0.10) 0%, rgba(63, 193, 255, 0.10) 100%);
        font-size: 1rem;
        color: #F5FAFF;
        letter-spacing: 0;
        text-shadow: 0 2px 4px #44D7B6;
        font-weight: 600;
        margin-bottom: 1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .iidata {
        .iitem {
            display: flex;
            align-items: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5rem;
            color: #fff;

            .name {
                color: #fff; //2333;
            }

            .value {
                color: #fff;
            }
        }
    }
}
</style>